import { render, staticRenderFns } from "./LessonTitleSection.vue?vue&type=template&id=3216567c&"
import script from "./LessonTitleSection.vue?vue&type=script&lang=ts&"
export * from "./LessonTitleSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports